import React from 'react'
import FrontExterior1 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-01.jpg"
import FrontExterior2 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-02.jpg"
import FrontExterior3 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-03.jpg"
import FrontExterior4 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-04.jpg"
import FrontExterior5 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-05.jpg"
import FrontExterior6 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-06.jpg"
import FrontExterior7 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-07.jpg"
import FrontExterior8 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-08.jpg"
import FrontExterior9 from "../assets/Gallery_photo/FrontExterior_Photo/gallery-font-exterior-09.jpg"

import RandomComp from '../components/PhotosComponent'


export const FrontExterior = () => {
  return (
    
    <RandomComp img1={FrontExterior1} img2={FrontExterior2} img3={FrontExterior3} img4={FrontExterior4} img5={FrontExterior5} img6={FrontExterior6} img7={FrontExterior7} img8={FrontExterior8} img9={FrontExterior9}></RandomComp>
    
  )
}
